import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';

import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CarteiraAutocompleteMapper } from '../shared/components/carteira-autocomplete/carteira-autocomplete.mapper';
import { catchError } from 'rxjs/operators';
import { handleError } from "../shared/util/error-util";
import { ExecutarHistorico } from './historico';


@Injectable({
  providedIn: 'root'
})
export class HistoricoService {

  private readonly url = '/v1/historico-enquadramento';
  private readonly _httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
  private readonly dateFormat = "yyyy-MM-dd";

  constructor(
    private readonly datePipe: DatePipe,
    private readonly httpClient: HttpClient,
    private readonly carteiraAutocompleteMapper: CarteiraAutocompleteMapper,
  ) {
  }

  executar(value: any): Observable<any>  {
      this.carteiraAutocompleteMapper.map(value);
      value["dataInicio"] = this.datePipe.transform(
        value["dataInicio"],
        this.dateFormat);

      value["dataFim"] = this.datePipe.transform(
        value["dataFim"],
        this.dateFormat);

      const headers = this._httpHeaders;
      const params: HttpParams = new HttpParams();
      const options = {headers, params};
  
      const model = Object.assign(new ExecutarHistorico(), value);
      model.regraId = value.regra;
      
      delete model.regra;
      delete model.page;
      console.log(model, value);
  
      return this.httpClient.post<any>(
        `${this.url}`,
        model,
        options
      );
  }

  search(value: any, pageSize = 20): Observable<any> {
    const headers = this._httpHeaders;
    let params: HttpParams = new HttpParams();

    params = params.set("size", pageSize + '');
    params = params.set("page", value.page);

    const options = {headers, params};
    return this.httpClient.get<any>(`${this.url}/all`, options);
  }

  download(id: number): Observable<HttpResponse<Blob>> {
    const headers = this._httpHeaders;
    return this.httpClient.get(`${this.url}/download/${id}`, {
      headers,
      responseType: "blob",
      observe: "response",
    }).pipe(catchError(handleError));
  }
}